import { useContextCurrency } from '@core/context';
import { useLanguage } from '@core/hook';
import { ECurrency } from '@core/type';
import { formatCurrencyArray } from '@core/util';

import { getTextPriceCurrencyProps } from './TextPrice';
import { Typography } from './Typography';
import { TextPriceTruncatedProps } from './interface-typography';

export const TextPriceTruncated = ({
  price,
  currency: currencyProps,
  ...restProps
}: TextPriceTruncatedProps) => {
  const { language } = useLanguage();
  const { currency: currencyContext } = useContextCurrency();
  const currentCurrency = currencyProps || currencyContext;
  const priceProps = formatCurrencyArray(language, currentCurrency, price);
  const isCurrencyAtTheBeginning = priceProps[0].type === 'currency';
  const { currency, integerValues, decimal, literal } = getTextPriceCurrencyProps(priceProps);

  if (isCurrencyAtTheBeginning) {
    return (
      <Typography whiteSpace={'nowrap'} {...restProps}>
        {currency}
        {integerValues.map(({ value }) => value)}
        {currentCurrency === ECurrency.CHF && `${decimal}-`}
      </Typography>
    );
  }

  return (
    <Typography whiteSpace={'nowrap'} {...restProps}>
      {integerValues.map(({ value }) => value)}
      {currentCurrency === ECurrency.CHF && `${decimal}-`}
      {literal}
      {currency}
    </Typography>
  );
};
